import template from './fullscreenLoader.html';
import './fullscreenLoader.scss';

export const FullscreenLoader = angular
    .module('checkout.components.fullscreenLoader', [])
    .component('fullscreenLoader', {
        template,
        bindings: {
            titleText: '<',
            titleImage: '<',
            description: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/fullscreenLoader/fullscreenLoader.js